

import {  Globe, Users, BookOpen, Home } from "lucide-react"
import AboutUsPage from "./AboutUsPage"
import PopupAuthComponent from "../../../components/popUpg/PopupAuthComponent"


// Composant Button
// const Button = ({ children, variant = "default", className = "", onClick, ...props }) => {
//   const baseClasses =
//     "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none"
//   const variants = {
//     default: "bg-blue-600 text-white hover:bg-blue-700 h-10 px-4 py-2",
//     outline: "border border-gray-300 bg-white hover:bg-gray-50 h-10 px-4 py-2",
//     ghost: "hover:bg-gray-100 text-gray-700 h-10 px-4 py-2",
//   }

//   return (
//     <button className={`${baseClasses} ${variants[variant]} ${className}`} onClick={onClick} {...props}>
//       {children}
//     </button>
//   )
// }

// Données de l'équipe
const teamMembers = [
  {
    name: "",
    role: "",
    bio: "",
    image:
      "https://cdn.vectorstock.com/i/1000v/74/57/green-user-icon-vector-42797457.jpg",
  },
  {
    name: "",
    role: "",
    bio: "",
    image:
      "https://cdn.vectorstock.com/i/1000v/74/57/green-user-icon-vector-42797457.jpg",
  },
  {
    name: "",
    role: "",
    bio: "",
    image:
      "https://cdn.vectorstock.com/i/1000v/74/57/green-user-icon-vector-42797457.jpg",
  },


]

// Données des partenaires
const partners = [
  {
    name: "",
    logo: "https://cdn.vectorstock.com/i/1000v/74/57/green-user-icon-vector-42797457.jpg",
  },
  {
    name: "",
    logo: "https://cdn.vectorstock.com/i/1000v/74/57/green-user-icon-vector-42797457.jpg",
  },
  {
    name: "",
    logo: "https://cdn.vectorstock.com/i/1000v/74/57/green-user-icon-vector-42797457.jpg",
  },
  {
    name: "",
    logo: "https://cdn.vectorstock.com/i/1000v/74/57/green-user-icon-vector-42797457.jpg",
  },

]

function AboutPage() {
  return (
    <>
      <div className="min-h-screen mt-20 bg-white">
        {/* Header */}


        {/* Hero Section */}
        <section className=" dark:bg-gray-900 from-green-600 to-blue-600 text-white py-20">
          <div className="max-w-7xl  mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl text-gray-900 dark:text-gray-200 md:text-5xl font-bold  mb-6">À propos de nous</h1>
            <p className="text-xl text-gray-800 font-bold dark:text-gray-200 max-w-3xl mx-auto">
              Ce site est une procédure qui vous permettra de comprendre les fonctionnalités des étapes à suivre en tant qu'étudiant Kenyan, sur le plan éducationnel, économique et social.
            </p>
          </div>
        </section>

        {/* Notre mission */}
        <section className="py-16 dark:bg-gray-900">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row gap-12 items-center">
              <div className="md:w-1/2">
                <h2 className="text-3xl font-bold dark:text-gray-200 text-gray-900 mb-6">Notre mission</h2>
                <p className="text-lg dark:text-gray-300 text-gray-600 mb-6">
                  Études au Kenya est né d'une vision simple : rendre l'éducation au Kenya accessible et transparente pour
                  les étudiants internationaux. Notre mission est de fournir des informations complètes, précises et à
                  jour sur les universités kenyanes, les options de logement et les démarches administratives.
                </p>
                <p className="text-lg dark:text-gray-300 text-gray-600">
                  Nous croyons que l'éducation transcende les frontières et que les étudiants méritent d'avoir accès à
                  toutes les informations nécessaires pour faire des choix éclairés concernant leur avenir académique.
                </p>
                <a
                  href="/mksp/kenya-education-info"
                  className="inline-flex items-center gap-2 mt-10 bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-6 rounded transition-colors duration-200 shadow-md hover:shadow-lg"
                >
                  Voir plus
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
              <div className="md:w-1/2">
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-green-50 p-6 rounded-lg text-center">
                    <Users className="h-10 w-10 text-green-600 mx-auto mb-4" />
                    <h3 className="font-semibold text-gray-900 mb-2">± 10</h3>
                    <p className="text-gray-600">Étudiants aidés</p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg text-center">
                    <BookOpen className="h-10 w-10 text-blue-600 mx-auto mb-4" />
                    <h3 className="font-semibold text-gray-900 mb-2">± 2</h3>
                    <p className="text-gray-600">Universités partenaires</p>
                  </div>
                  <div className="bg-purple-50 p-6 rounded-lg text-center">
                    <Home className="h-10 w-10 text-purple-600 mx-auto mb-4" />
                    <h3 className="font-semibold text-gray-900 mb-2">± 12</h3>
                    <p className="text-gray-600">Logements référencés</p>
                  </div>
                  <div className="bg-yellow-50 p-6 rounded-lg text-center">
                    <Globe className="h-10 w-10 text-yellow-600 mx-auto mb-4" />
                    <h3 className="font-semibold text-gray-900 mb-2">± 20</h3>
                    <p className="text-gray-600">Pays d'origine</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AboutUsPage />

        {/* Notre histoire */}
        <section className="py-16 bgC bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-100 mb-12 text-center">Notre histoire</h2>
            <div className="relative">
              {/* Timeline */}
              <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-green-200"></div>

              {/* Timeline items */}
              <div className="space-y-24 relative">
                <div className="flex flex-col md:flex-row items-center">
                  <div className="md:w-1/2 md:pr-12 md:text-right">
                    <h3 className="text-xl font-semibold text-gray-100 mb-2">2023</h3>
                    <h4 className="text-lg font-medium text-door-dark mb-3">La naissance d'une idée</h4>
                    {/* <p className="text-gray-300">
                    , arrive au Kenya et constate le manque d'informations
                    centralisées pour les étudiants internationaux.
                  </p> */}
                  </div>
                  <div className="mx-auto md:mx-0 my-6 md:my-0 z-10 bg-white rounded-full p-2 border-4 border-green-200 animate-fade-in-scale">
                    <div className="bg-green-600 rounded-full h-6 w-6 animate-ping-smooth"></div>
                  </div>

                  <div className="md:w-1/2 md:pl-12"></div>
                </div>

                <div className="flex flex-col md:flex-row items-center">
                  <div className="md:w-1/2 md:pr-12"></div>
                  <div className="mx-auto md:mx-0 my-6 md:my-0 z-10 bg-white rounded-full p-2 border-4 border-green-200">
                    <div className="bg-green-600 rounded-full h-6 w-6"></div>
                  </div>
                  <div className="md:w-1/2 md:pl-12 md:text-left">
                    <h3 className="text-xl font-semibold text-gray-100 mb-2">2025</h3>
                    <h4 className="text-lg font-medium text-door-dark mb-3">Lancement de la plateforme</h4>
                    <p className="text-gray-300">
                      Après deux ans de recherche et de développement, la première version d'Études au Kenya est lancée,
                      offrant des informations sur 9 universités.
                    </p>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row items-center">
                  <div className="md:w-1/2 md:pr-12 md:text-right">
                    <h3 className="text-xl font-semibold text-gray-100 mb-2">2025</h3>
                    <h4 className="text-lg font-medium text-door-dark mb-3">Expansion des services</h4>
                    <p className="text-gray-300">
                      Ajout des sections sur les logements étudiants et le guide complet pour étudier au Kenya, en
                      collaboration avec des experts locaux.
                    </p>
                  </div>
                  <div className="mx-auto md:mx-0 my-6 md:my-0 z-10 bg-white rounded-full p-2 border-4 border-green-200">
                    <div className="bg-green-600 rounded-full h-6 w-6"></div>
                  </div>
                  <div className="md:w-1/2 md:pl-12"></div>
                </div>

                <div className="flex flex-col md:flex-row items-center">
                  <div className="md:w-1/2 md:pr-12"></div>
                  <div className="mx-auto md:mx-0 my-6 md:my-0 z-10 bg-white rounded-full p-2 border-4 border-green-200">
                    <div className="bg-green-600 rounded-full h-6 w-6"></div>
                  </div>
                  <div className="md:w-1/2 md:pl-12 md:text-left">
                    <h3 className="text-xl font-semibold text-gray-100 mb-2">Aujourd'hui</h3>
                    <h4 className="text-lg font-medium text-door-dark mb-3">Une ressource incontournable</h4>
                    <p className="text-gray-300">
                      Études au Kenya est devenu la référence pour les étudiants internationaux souhaitant étudier au
                      Kenya, avec des milliers d'utilisateurs mensuels.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Notre équipe */}
        <section className="py-16 dark:bg-gray-900">
          <div className="max-w-7xl  mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-200 mb-12 text-center">Notre équipe</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {teamMembers.map((member, index) => (
                <div
                  key={index}
                  className="bg-white dark:bg-gray-800 border dark:border-gray-600 rounded-lg overflow-hidden shadow-md transition-transform hover:scale-105"
                >
                  <img
                    src={member.image || "/placeholder.svg"}
                    alt={member.name}
                    className="w-full h-64 object-cover object-center"
                  />
                  <div className="p-6">
                    <h3 className="font-semibold dark:text-gray-300 text-lg text-gray-900 mb-1">{member.name}</h3>
                    <p className="text-green-600 mb-3">{member.role}</p>
                    <p className="text-gray-600 dark:text-gray-400  text-sm">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Nos partenaires */}
        <section className="py-16 dark:bg-gray-900 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold dark:text-gray-200 text-gray-900 mb-12 text-center">Nos partenaires</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              {partners.map((partner, index) => (
                <div key={index} className="bg-white dark:border dark:border-gray-700 dark:bg-gray-800  p-6 rounded-lg shadow-sm flex flex-col items-center justify-center">
                  <img
                    src={partner.logo || "/placeholder.svg"}
                    alt={partner.name}
                    className="h-16 w-16 object-cover rounded-full mb-4"
                  />
                  <h3 className="font-medium text-gray-900 dark:text-gray-200  text-center">{partner.name}</h3>
                </div>
              ))}
            </div>
          </div>
        </section>


      </div>
      <PopupAuthComponent />
    </>
  )
}

export default AboutPage
